import React from 'react';

/**
 * Tab Navigation Component
 * Renders the tab navigation bar for SubmissionDetail page
 */
const TabNavigation = ({ activeTab, onTabChange, className = '' }) => {
    const tabs = [
        { id: 'overview', label: 'OVERVIEW', icon: '📊' },
        { id: 'playbook', label: 'AI PLAYBOOK', icon: '🎯' },
        { id: 'analytics', label: 'ANALYTICS', icon: '📈' },
        { id: 'activities', label: 'ACTIVITIES', icon: '⚡' },
        { id: 'timeline', label: 'TIMELINE', icon: '🕐' },
        { id: 'risks', label: 'RISKS', icon: '⚠️' }
    ];

    return (
        <div className={`border-b border-gray-700 ${className}`}>
            <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex gap-2 overflow-x-auto">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => onTabChange(tab.id)}
                            className={`
                px-6 py-3 text-sm font-bold uppercase tracking-wider
                transition-all duration-150 border-b-2 whitespace-nowrap
                flex items-center gap-2
                ${activeTab === tab.id
                                    ? 'border-blue-500 bg-blue-600/10 text-blue-400'
                                    : 'border-transparent text-gray-400 hover:bg-gray-700/50 hover:text-white'
                                }
              `}
                        >
                            <span>{tab.icon}</span>
                            <span>{tab.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TabNavigation;
